import './App.css';
import React from "react";
import { Route, HashRouter } from "react-router-dom";
import { Expertise, Form, Tribu, Login, Result } from './Pages'

function App() {
    
    return (
        <HashRouter>
            <div className="App">
                <div className="content">
                    <Route exact path='/' component={Login} />
                    <Route exact path="/tribu" component={Tribu} />
                    <Route exact path="/tribu/:tribu" component={Expertise} />
                    <Route exact path="/tribu/:tribu/:expertise" component={Form} />
                    <Route exact path="/result" component={Result}/>
                </div>
            </div>
        </HashRouter>
    );
}

export default App;
